export const BLOG_REQUESTS_RESET_STATE = 'BLOG_REQUESTS_RESET_STATE';
export const BLOG_REQUESTS_CURRENT_ITEM = 'BLOG_REQUESTS_CURRENT_ITEM';

export const BLOG_REQUESTS_REQUEST_LOADING = 'BLOG_REQUESTS_REQUEST_LOADING';
export const BLOG_REQUESTS_REQUEST_SUCCESS = 'BLOG_REQUESTS_REQUEST_SUCCESS';
export const BLOG_REQUESTS_REQUEST_FAILED = 'BLOG_REQUESTS_REQUEST_FAILED';

export const BLOG_REQUESTS_CURRENT_ACTION = 'BLOG_REQUESTS_CURRENT_ACTION';
export const BLOG_REQUESTS_RESET_ACTION = 'BLOG_REQUESTS_RESET_ACTION';